import React, { useEffect } from "react";
import { CoachSettingsPlan } from "../../../../components/settings/CoachSettingsPlan";
import TrackInfoTool from "../../../../components/tools/TrackInfoTool";
import { useCurrentUser } from "../../../../hooks/useCurrentUser";
import { useQueryClient } from "@tanstack/react-query";
import { CURRENT_USER_QUERY_KEY } from "../../../../wrappers/current-user/CurrentUserWrapper";
import { useAddons } from "../../../../hooks/useAddons";

export function CoachSettingsPlanRoute() {
  const user = useCurrentUser();
  const { data: addons, isLoading: isLoadingAddons } = useAddons();
  const queryClient = useQueryClient();
  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: [CURRENT_USER_QUERY_KEY],
      refetchType: "all",
    });
  }, []);

  return (
    <>
      {user && <CoachSettingsPlan user={user} addons={addons} />}
      <TrackInfoTool
        trackInfo={{
          name: "Coach - Plan",
        }}
      />
    </>
  );
}
